/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Modality } from './Modality';
import {
    instanceOfModality,
    ModalityFromJSON,
    ModalityFromJSONTyped,
    ModalityToJSON,
} from './Modality';

/**
 * @type TrackItMeasurementParameterModalityDtoValue
 * 
 * @export
 */
export type TrackItMeasurementParameterModalityDtoValue = Modality;


export function TrackItMeasurementParameterModalityDtoValueFromJSON(json: any): TrackItMeasurementParameterModalityDtoValue {
    return TrackItMeasurementParameterModalityDtoValueFromJSONTyped(json, false);
}

export function TrackItMeasurementParameterModalityDtoValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementParameterModalityDtoValue {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...ModalityFromJSONTyped(json, true) };
    return  ModalityFromJSONTyped(json, true);
}

export function TrackItMeasurementParameterModalityDtoValueToJSON(value?: TrackItMeasurementParameterModalityDtoValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfModality(value)) {
        return ModalityToJSON(value as Modality);
    }

    return {};
}

/**
 * Check if a given object implements the TrackItMeasurementParameterModalityDtoValue interface.
 */
export function instanceOfTrackItMeasurementParameterModalityDtoValue(value: any): value is TrackItMeasurementParameterModalityDtoValue {
    if (instanceOfModality(value)) return true;
    return false;
}

